import { useQuery } from '@tanstack/react-query';

import { extractErrorMessage } from '@/api/extractErrorMessage';
import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';

const GET_PROJECT_LOCATION = graphql(`
  query GetProjectLocation($projectId: ID!) {
    projectById(id: $projectId) {
      id
      publicId
      version
    }
  }
`);

/** Where a Project lives, by either of its ids. */
const useGetProjectLocation = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.location(String(projectId)),
    queryFn: () =>
      gqlClient.request(GET_PROJECT_LOCATION, { projectId: projectId! }),
    // A client can hold the id of a Project it can no longer reach, so failure
    // is a normal outcome here rather than a fault, and retrying cannot
    // recover it.
    retry: (failureCount, error) =>
      failureCount < 3 && extractErrorMessage(error).code !== 'NOT_FOUND',
  });

  return { project: data?.projectById, ...rest };
};

export default useGetProjectLocation;
